document.addEventListener("DOMContentLoaded", () => {
  const headers = document.querySelectorAll("[data-toretark-header]");

  headers.forEach((header) => {
    /**
     * ============================================================
     * Search Modal
     * ============================================================
     */

    const announcementBars = document.querySelectorAll(
      "[data-toretark-announcement-bar]"
    );
    
    announcementBars.forEach((bar) => {
      const items = bar.querySelectorAll(
        "[data-toretark-announcement-item]"
      );
    
      if (items.length <= 1) {
        return;
      }
    
      const interval = Number(bar.dataset.interval) || 3000;
      let currentIndex = 0;
    
      window.setInterval(() => {
        items[currentIndex].classList.remove("is-active");
    
        currentIndex = (currentIndex + 1) % items.length;
    
        items[currentIndex].classList.add("is-active");
      }, interval);
    });

    const container = header.closest("#toretark-header-container");

    const searchModal = container
      ? container.querySelector("[data-toretark-search-modal]")
      : null;

    const searchOpenButtons = header.querySelectorAll(
      "[data-toretark-search-open]",
    );

    const searchCloseButtons = searchModal
      ? searchModal.querySelectorAll("[data-toretark-search-close]")
      : [];

    const searchInput = searchModal
      ? searchModal.querySelector("[data-toretark-search-input]")
      : null;


    /**
     * ============================================================
     * Mobile Menu
     * ============================================================
     */

    const mobileToggle = header.querySelector(
      "[data-toretark-mobile-toggle]",
    );

    const mobileMenu = header.querySelector(
      "[data-toretark-mobile-menu]",
    );

    const menuIcon = header.querySelector(
      "[data-toretark-menu-icon]",
    );

    const closeIcon = header.querySelector(
      "[data-toretark-close-icon]",
    );

    let mobileMenuTimer = null;

    const openMobileMenu = () => {
      if (!mobileToggle || !mobileMenu) {
        return;
      }

      if (mobileMenuTimer) {
        window.clearTimeout(mobileMenuTimer);
        mobileMenuTimer = null;
      }

      mobileMenu.hidden = false;
      mobileMenu.style.height = "0px";

      // Force a layout read so the 0 -> content height transition runs reliably.
      mobileMenu.offsetHeight;

      mobileMenu.classList.add("is-open");
      mobileMenu.style.height = `${mobileMenu.scrollHeight}px`;

      mobileToggle.setAttribute("aria-expanded", "true");

      if (menuIcon) {
        menuIcon.hidden = true;
      }

      if (closeIcon) {
        closeIcon.hidden = false;
      }

      mobileMenuTimer = window.setTimeout(() => {
        if (mobileMenu.classList.contains("is-open")) {
          mobileMenu.style.height = "auto";
        }

        mobileMenuTimer = null;
      }, 320);
    };

    const closeMobileMenu = () => {
      if (!mobileToggle || !mobileMenu || mobileMenu.hidden) {
        return;
      }

      if (mobileMenuTimer) {
        window.clearTimeout(mobileMenuTimer);
        mobileMenuTimer = null;
      }

      mobileMenu.style.height = `${mobileMenu.scrollHeight}px`;

      // Force the current expanded height to be committed before collapsing.
      mobileMenu.offsetHeight;

      mobileMenu.classList.remove("is-open");
      mobileMenu.style.height = "0px";

      mobileToggle.setAttribute("aria-expanded", "false");

      if (menuIcon) {
        menuIcon.hidden = false;
      }

      if (closeIcon) {
        closeIcon.hidden = true;
      }

      mobileMenuTimer = window.setTimeout(() => {
        if (!mobileMenu.classList.contains("is-open")) {
          mobileMenu.hidden = true;
          mobileMenu.style.height = "";
        }

        mobileMenuTimer = null;
      }, 320);
    };

    if (mobileToggle && mobileMenu) {
      mobileToggle.addEventListener("click", (event) => {
        event.preventDefault();

        if (mobileMenu.classList.contains("is-open")) {
          closeMobileMenu();
        } else {
          openMobileMenu();
        }
      });

      mobileMenu.querySelectorAll(".toretark-header__mobile-nav-link").forEach((link) => {
        link.addEventListener("click", () => {
          closeMobileMenu();
        });
      });

      const mobileAccount = mobileMenu.querySelector(
        ".toretark-header__mobile-account",
      );

      if (mobileAccount) {
        mobileAccount.addEventListener("click", () => {
          closeMobileMenu();
        });
      }
    }

    /**
     * ============================================================
     * Cart Drawer
     * ============================================================
     */

    const cartOpenButtons = header.querySelectorAll(
      "[data-toretark-cart-open]",
    );

    cartOpenButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();

        const cartDrawer = document.querySelector("cart-drawer");

        if (cartDrawer && typeof cartDrawer.open === "function") {
          cartDrawer.open(button);
          return;
        }

        /**
         * 如果当前主题不存在 Cart Drawer，
         * 则回退到购物车页面。
         */
        const root =
          window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root
            : "/";

        window.location.href = root.replace(/\/?$/, "/") + "cart";
      });
    });

    /**
     * ============================================================
     * Search Modal Open
     * ============================================================
     */

    const openSearchModal = () => {
      if (!searchModal) {
        return;
      }

      searchModal.hidden = false;

      searchModal.setAttribute("aria-hidden", "false");

      document.body.classList.add("toretark-modal-open");

      requestAnimationFrame(() => {
        searchModal.classList.add("is-open");

        setTimeout(() => {
          if (searchInput) {
            searchInput.focus();
          }
        }, 100);
      });
    };

    /**
     * ============================================================
     * Search Modal Close
     * ============================================================
     */

    const closeSearchModal = () => {
      if (!searchModal) {
        return;
      }

      searchModal.classList.remove("is-open");

      searchModal.setAttribute("aria-hidden", "true");

      document.body.classList.remove("toretark-modal-open");

      setTimeout(() => {
        searchModal.hidden = true;
      }, 200);
    };

    /**
     * Search Open Buttons
     */

    searchOpenButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();

        if (mobileMenu && mobileMenu.contains(button)) {
          closeMobileMenu();
        }

        openSearchModal();
      });
    });

    /**
     * Search Close Buttons
     */

    searchCloseButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();

        closeSearchModal();
      });
    });

    /**
     * 点击搜索遮罩关闭
     */

    if (searchModal) {
      searchModal.addEventListener("click", (event) => {
        if (event.target === searchModal) {
          closeSearchModal();
        }
      });
    }

    /**
     * ESC 关闭搜索
     */

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") {
        return;
      }

      if (searchModal && searchModal.classList.contains("is-open")) {
        closeSearchModal();
      }
    });
  });
});

/**
 * ============================================================
 * Header Cart Count
 * ============================================================
 */

window.toretarkUpdateHeaderCartCount = function (count) {
  const cartCountElements = document.querySelectorAll(
    "[data-toretark-cart-count]",
  );

  const itemCount = Number(count) || 0;

  cartCountElements.forEach((element) => {
    element.textContent = itemCount;

    if (itemCount > 0) {
      element.classList.remove("is-hidden");

      element.removeAttribute("hidden");

      element.setAttribute("aria-hidden", "false");
    } else {
      element.classList.add("is-hidden");

      element.setAttribute("aria-hidden", "true");
    }
  });
};

/**
 * ============================================================
 * Refresh Header Cart Count
 * ============================================================
 */

window.toretarkRefreshHeaderCartCount = function () {
  const root =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";

  const cartUrl = root.replace(/\/?$/, "/") + "cart.js";

  return fetch(cartUrl, {
    method: "GET",

    credentials: "same-origin",

    headers: {
      Accept: "application/json",
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to fetch cart");
      }

      return response.json();
    })

    .then((cart) => {
      if (typeof window.toretarkUpdateHeaderCartCount === "function") {
        window.toretarkUpdateHeaderCartCount(cart.item_count);
      }
      return cart;
    })

    .catch((error) => {
      console.error("[Toretark Header] Failed to refresh cart count:", error);

      return null;
    });
};

/**
 * ============================================================
 * Common Cart Events
 * ============================================================
 */

["cart:updated", "cart:refresh", "cart:update", "product:added"].forEach(
  (eventName) => {
    document.addEventListener(eventName, () => {
      if (typeof window.toretarkRefreshHeaderCartCount === "function") {
        window.toretarkRefreshHeaderCartCount();
      }
    });
  },
);

/**
 * ============================================================
 * Shopify PUB_SUB_EVENTS.cartUpdate
 * ============================================================
 */

(function () {
  let unsubscribeCartUpdate = null;

  function initCartUpdateListener() {
    if (unsubscribeCartUpdate) {
      return;
    }

    if (
      typeof subscribe !== "function" ||
      typeof PUB_SUB_EVENTS === "undefined" ||
      !PUB_SUB_EVENTS.cartUpdate
    ) {
      return;
    }

    unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const cartData = event && event.cartData ? event.cartData : null;

      /**
       * cart/change.js
       *
       * 返回完整购物车数据，
       * 所以直接使用 item_count。
       */

      if (cartData && typeof cartData.item_count === "number") {
        if (typeof window.toretarkUpdateHeaderCartCount === "function") {
          window.toretarkUpdateHeaderCartCount(cartData.item_count);
        }

        return;
      }

      /**
       * cart/add.js
       *
       * 通常返回新增 Line Item，
       * 不一定包含 item_count。
       *
       * 所以重新请求 cart.js。
       */

      if (typeof window.toretarkRefreshHeaderCartCount === "function") {
        window.toretarkRefreshHeaderCartCount();
      }
    });
  }

  /**
   * 尝试立即订阅
   */

  initCartUpdateListener();

  /**
   * DOMContentLoaded 后再次尝试
   */

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCartUpdateListener, {
      once: true,
    });
  }

  /**
   * 页面资源加载完成后再次尝试
   */

  window.addEventListener("load", initCartUpdateListener, {
    once: true,
  });
})();
